module.exports = __webpack_public_path__ + "static/media/1.2db0f5ab.jpg";